import Sentry from './Sentry'

export default Sentry
